import { useHistory } from 'react-router'

import { formatDateTime } from '../../helpers/formatters'
import { midGray } from '../../theme/colors'
import { Text } from '../Text/Text'
import { IssueListGrid } from './IssueListGrid'

interface IssueRowItemProps {
  issue: any
}

export function IssueRowItem({ issue }: IssueRowItemProps) {
  const history = useHistory()

  const handleOnClick = () => {
    const issueClass = issue.issue_class
    if (issueClass === 'JOB') {
      history.push(`/issues/${issue.id}/show`)
    } else if (issueClass === 'LOAD') {
      history.push(`/load-issues/${issue.id}/show`)
    } else if (issueClass === 'GENERIC') {
      history.push(`/generic-issues/${issue.id}/show`)
    }
  }

  return (
    <IssueListGrid isItem onClick={handleOnClick}>
      <Text variant="paragraph1" fontColor={midGray}>
        {issue.human_type}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}>
        {issue.human_status}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}>
        {formatDateTime(issue.date_created)}
      </Text>
    </IssueListGrid>
  )
}
